<template>
  <span id="plans" v-if="unitPeriod">

    <!-- <div id="plan-credits">
      <span class="ds-main ds-color bs-border-color">{{credits}} Credit Hours</span>
    </div> -->

    <!-- Tabs for Available Plans -->
    <div id="plan-tabs">
      <ul v-if="plans.length > 1">
        <li
          v-for="(plan, index) in plans"
          class="ds-main ds-color ds-border-color plan-tab"
          :class="{inactive: activePlan != plan}"
          :key="plan.id"
          @click="activePlanIndex = index"
        >
          <div class = 'plan-tab-name'>{{plan.plan.name}}</div>
        </li>
      </ul>
    </div>

    <div class = 'plan-types'>
      <div
        class = 'plan-type ds-main ds-color'
        v-for = 'type in planTypes'
        @click = 'selectedPlanType = type'
        :class = '{selected: selectedPlanType === type, "ds-background": selectedPlanType === type}'
        :key = 'type[0]'
      >
        <i class = 'fas' :class = 'type[1]'></i>
        <span>{{ type[0] }}</span>
      </div>
    </div>

    <!-- Selected Plan -->
    <transition name="up-down" mode="out-in">
      <component
        :is="selectedPlanType[0]"
        :termIdentifier = 'termIdentifier'
        v-for="plan in plans"
        v-if="activePlan === plan"
        :key="plan.id"
        :terms="formatTerms(plan.plan_terms)"
      >
      </component>
    </transition>
  </span>
</template>

<script>
  import {Plan, Graph, Grid, formatTerms} from '@unm-idi/vue-degree-plan'
  import {sortBy} from 'lodash'
  // import http from '../http'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'UnitPlans',

    data() {
      const planTypes = [['Plan', 'fa-list'], ['Grid', 'fa-th'], ['Graph', 'fa-share-alt']]
      return {
        // unit: null,
        activePlanIndex: 0,
        selectedPlanType: planTypes[0],
        planTypes: planTypes,
        formatTerms: formatTerms
      }
    },

    mounted() {
      this.getPlans()
    },

    computed: {
      ...mapGetters(['termIdentifier']),
      ...mapState(['unitPeriod']),

      selectedTermItem: {
        get() {
          return this.$store.state.selectedTermItem
        },
        set(item) {
          this.$store.commit('setSelectedTermItem', item)
        }
      },

      name() {
        return this.unitPeriod[this.unitPeriod.type].name
      },

      college() {
        return this.unitPeriod.college.name
      },

      credits() {
        return this.unitPeriod.period_degree_joins[0].total_credit_hours
      },

      plans() {
        return this.unitPeriod.period_degree_joins[0].plan_period_joins
      },

      activePlan() {
        return this.plans[this.activePlanIndex]
      }
    },

    // beforeRouteEnter(to, from, next) {
    //   // // Pulls all plan information
    //   http.get('universities/' + process.env.UNIVERSITY_ID + '/academic_periods/' + to.params.period_id + '/university_layouts/' + to.params.layout_id + '.json').then(response => {
    //     next(vm => {
    //       vm.unitPeriod = response.data
    //     })
    //   })
    // },

    methods: {
      sortTerms(terms) {
        return sortBy(terms, 'position')
      },

      getPlans() {
        // Pulls all plan information
        // this.$http.get('universities/' + this.$store.state.id + '/academic_periods/' + this.$route.params.period_id + '/university_layouts/' + this.$route.params.layout_id + '.json').then(response => {
        //   this.name = response.data[response.data.type].name
        //   this.college = response.data.college.name
        //   this.credits = response.data.period_degree_joins[0].total_credit_hours
        //   this.plans = response.data.period_degree_joins[0].plan_period_joins
        //   this.activePlan = this.plans[0].id
        // })
      }
    },

    components: {
      Plan,
      Graph,
      Grid
    }
  }
</script>



// WEBPACK FOOTER //
// UnitPlans.vue?48c7cafc